import './index.css';
import { useState, useLayoutEffect } from 'react';
import classnames from 'classnames';

var styles = {"collapsible":"magritte-collapsible___wB5Ls_1-0-25","opened":"magritte-opened___-eg5G_1-0-25"};

const useCollapsible = (ref, expanded, deps = []) => {
    const [isOpened, setIsOpened] = useState(expanded);
    useLayoutEffect(() => {
        if (ref.current) {
            const openedHeight = `${ref.current.scrollHeight}px`;
            ref.current.style.maxHeight = expanded ? openedHeight : '0px';
        }
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [expanded, ...deps]);
    useLayoutEffect(() => {
        if (!expanded) {
            setIsOpened(false);
            return undefined;
        }
        const transitionEndListener = (event) => {
            if (event.target === event.currentTarget) {
                setIsOpened(true);
            }
        };
        const currentElement = ref.current;
        currentElement?.addEventListener('transitionend', transitionEndListener);
        return () => {
            currentElement?.removeEventListener('transitionend', transitionEndListener);
        };
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [expanded]);
    return {
        collapsibleClasses: classnames(styles.collapsible, {
            [styles.opened]: isOpened,
        }),
    };
};

export { useCollapsible };
//# sourceMappingURL=index.js.map
